import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const assignMaterialVehicleDetailsList = async (data) => {
  try {
    const response = await postRequest(`${urls.WT_ASSIGN_MATERIAL_VEHICLE_LIST}`, data);
    // Return raw response without any filtering or shape modification.
    return response;
  } catch (err) {
    return err;
  }
};
